import {Injectable} from '@angular/core';
import {RouterHelper} from '../../util/router-helper';
import {LocalStorageService} from '../local-storage/local-storage.service';

export const FORWARD_LOCAL_STORAGE_ITEM_NAME = 'forwardToLastArea2';

export interface ForwardSettings {
  date: Date | string;
  url: string;
}

@Injectable({
  providedIn: 'root'
})
export class ForwardToLastAreaService {
  constructor(private localStorage: LocalStorageService) {}

  /**
   * load forward settings from localStorage
   */
  getCurrentForwardSettings(): ForwardSettings | null {
    const setting = this.localStorage.getItem(FORWARD_LOCAL_STORAGE_ITEM_NAME);
    return setting ? (JSON.parse(setting) as ForwardSettings) : null;
  }

  getCurrentForwardSettingsOrDefault(defaultState: string): string {
    const forwardSettings = this.getCurrentForwardSettings();
    if (forwardSettings !== null && forwardSettings !== undefined) {
      // do not use query params when redirect is loaded from local storage, as this could be from a different user/login
      return RouterHelper.removeQuery(forwardSettings.url);
    } else {
      return defaultState;
    }
  }

  /**
   * persists ForwardSettings to local storage
   */
  persistForwardToLocalStorage(newForwardSettings: ForwardSettings): void {
    const newForwardSettingsString = JSON.stringify(newForwardSettings);

    this.localStorage.setItem(FORWARD_LOCAL_STORAGE_ITEM_NAME, newForwardSettingsString);
  }
}
